import React from 'react';

type Props = {
    className   : string
    field       : any
    options     : any  // ???? It's no Option[] !!!!!
    size        : string
    value       : any
    disabled    : boolean

    onClick     : callback
    onReset     : callback
    onChange    : callback

    children?   : any
}

export default function FieldMultiselect_FormValueEmpty(props: Props) {
    let label = props.field.placeholder;

    // check if all values option is enabled
    if (!!props.field.allValuesOption && !props.options) {
        label = props.field.allValuesOptionLabel;
    }

    const classes = Classes("ui5-txt-no-accent-default", "ui5-field-form-editable", "dropdown-form", "h-36", props.className, {
        "is-disabled": props.disabled
    })

    return (
        <React.Fragment>
            <div className  = {classes}
                 onClick    = {props.onClick}>

                {_.get(props.field.components, 'ValueIcon', false)}

                {label}

            </div>

            {props.children}

        </React.Fragment>
    )
}
